<template>
    <div id="admin-layout" class="flex-container flex-column">
        <alzata-app-header />
        <div class="flex-container flex-fill">
            <alzata-side-menu />
            <main role="main" class="flex-fill p-3">
                <router-view />
            </main>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'AlzataAdminLayout',
    computed: {
        ...mapState({
            user: state => state.iam.user,
        }),
    },
};
</script>